import { fetchUtils } from 'react-admin';
import { getValidationErrors } from './getValidationErrors';


const getOptions = (options = {}) => {
	if (!options.headers) {
		options.headers = new Headers({ Accept: 'application/json' });
	}
	return options;
}

// A pallet number read off an sscc column is 18 digits, past Number.MAX_SAFE_INTEGER, so
// JSON.parse drops its last digits. The raw response text still holds them: these ids are
// quoted there before parsing, and reach the app as strings.
// Every one of them is quoted, not only the oversized ones, so that a pallet number has a
// single type everywhere and short ones cannot miss a lookup keyed by the long ones.
// The leading `,` or `{` keeps this out of string values, where a quote is escaped as \".
const PALLET_NUMBER_ID = /([,{]\s*"(?:ext_id|source_pallet_ext_id|pallet_ext_id)"\s*:\s*)(\d+)/g;

const withTextIds = (response) => {
	if (response.json === undefined) return response;
	return { ...response, json: JSON.parse(response.body.replace(PALLET_NUMBER_ID, '$1"$2"')) };
};

const parseStructuredErrors = (errors) => {
	const messages = [];
	const parsedErrors = errors.map((err) => {
		try {
			const parsed = JSON.parse(err.description);
			if (parsed.code) {
				const enriched = {
					...err,
					code: parsed.code,
					description: parsed.message || err.description,
				};
				if (parsed.fields) enriched.fields = parsed.fields;
				if (parsed.field) enriched.field = parsed.field;
				return enriched;
			}
		} catch {
			// not JSON, keep as-is
		}
		return err;
	});
	for (const err of parsedErrors) {
		if (err.description) {
			messages.push(err.description);
		}
	}
	return { messages, errors: parsedErrors };
};

const extractErrorMessage = (error) => {
	const body = error.body;
	if (body) {
		if (body.message) return body.message;
		// OAuth2 errors format: { error: '...', error_description: '...' }
		if (body.error_description || body.error) {
			return body.error_description || body.error;
		}
	}
	return error.message;
};

export const httpClient = (url, options = {}) => {
	return fetchUtils.fetchJson(url, getOptions(options)).then(withTextIds).catch((error) => {
		const validationErrors = getValidationErrors(error);
		if (error.status === 400 && validationErrors.length > 0) {
			const { messages, errors } = parseStructuredErrors(validationErrors);
			error.body = errors;
			if (messages.length > 0) {
				error.message = messages.join(". ");
			}
		} else {
			error.message = extractErrorMessage(error);
		}
		throw error;
	});
}

export const httpClientRaw = (url, options = {}) => {
	return fetch(url, getOptions(options));
}
